<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('category')">
            <app-default-button
                :title="$fieldTitle('add', 'category', true)"
                v-if="$can('create_finance_categories')"
                @click="openModal()"
            />
            <!-- <app-default-button class="btn-success ml-2"
                :title="$t('transaction')"
                v-if="$can('create_transaction_accounts')"
                @click="redirectTo('/finance/transactions')"
            /> -->
        </app-page-top-section>

        <app-table
            id="finance-category-table"
            :options="options"
            @action="triggerActions"
        />

        <app-finance-category-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-finance-category-translate
            v-if="isTranslateModalActive"
            v-model="isTranslateModalActive"
            :category-id="categoryId"
            @close="isTranslateModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('finance-category-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import FinanceCategoryMixin from "../../Mixins/FinanceCategoryMixin";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";

export default {
    name  : "FinanceCategory",
    mixins: [HelperMixin, FinanceCategoryMixin],
    data() {
        return {
            isModalTypeActive: false,
            isModalActive    : false,
            isTranslateModalActive: false,
            selectedUrl      : '',
            categoryId       : null,
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/finance-categories/${row.id}`;
                this.isModalActive = true;
            } else if (action.title === this.$t('translate')) {
                this.categoryId = row.id;
                this.isTranslateModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>

<style scoped>
::v-deep .btn-success {
    color: #ffffff !important;
    background-color: #46c35f !important;
    border-color: #46c35f !important;
}
</style>
